export default {
  namespaced: true,
  state: {
    isModalOpen: false,
    previousRouteName: null,
    isOnboardingRedesign: true,
    isSoftRejected: false,
  },
  mutations: {
    SET_MODAL_STATE(state, modalState) {
      state.isModalOpen = modalState
    },
    SET_STATE (state, payload) {
      state[payload.state] = payload.value
    },
    SET_ONBOARDING_REDESIGN (state, value) {
      state.isOnboardingRedesign = value
    },
    SET_IS_SOFT_REJECTED (state, value) {
      state.isSoftRejected = value
    }
  },
  getters: {},
  actions: {}
}